import React, { useState } from 'react';
import './PresidentMessages.css';

import Pimg from "./Images/Ppic1.jpg";

const PresidentMessage = ({
  name = "Monty Tiwari ( Monty Baba )",
  position = "President & CEO",
  organization = "BG RealEstate360",
  message = "On behalf of BG RealEstate360, I am proud to reflect on a journey built on trust, experience, and long-term vision since 2001. What began as a strong offline foundation has evolved into a modern digital platform, enabling us to deliver transparent and reliable real estate solutions. As we continue to grow across key industrial regions including Ankleshwar, Dahej, Jhagadia, Panoli, and the Bharuch district, we remain committed to creating real value and helping our clients make confident, informed property decisions.",
  year = "2001",
  avatar = Pimg,
  showSignature = true,
  showDate = true,
  enableDownload = true,
  enablePrint = true
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const currentDate = new Date().toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

  // Function to download message as PDF/text file
  const handleDownload = () => {
    if (!enableDownload) return;
    
    setIsDownloading(true);
    
    // Create message content for download
    const downloadContent = `
PRESIDENT'S MESSAGE
===================

Organization: ${organization}
Year: ${year}
Date: ${currentDate}

From: ${name}
Position: ${position}

Message:
${message}

${showSignature ? `Signature: ${name}` : ''}
${showDate ? `Date: ${currentDate}` : ''}

© ${organization} ${year}
    `;

    // Create blob and download
    const blob = new Blob([downloadContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    
    link.href = url;
    link.download = `President_Message_${name.replace(/\s+/g, '_')}_${year}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    // Reset downloading state
    setTimeout(() => setIsDownloading(false), 1000);
  };

  // Function to print message
  const handlePrint = () => {
    if (!enablePrint) return;
    
    setIsPrinting(true);
    
    // Create print content
    const printContent = `
      <html>
        <head>
          <title>President's Message - ${name}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 40px; max-width: 800px; margin: 0 auto; }
            .print-header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 30px; }
            .print-title { font-size: 28px; font-weight: bold; color: #2c3e50; margin: 0; }
            .print-subtitle { font-size: 16px; color: #7f8c8d; margin: 5px 0 20px 0; }
            .president-info { background: #f8f9fa; padding: 20px; border-radius: 10px; margin-bottom: 30px; }
            .president-name { font-size: 22px; font-weight: bold; color: #2c3e50; margin: 0; }
            .president-position { color: #3498db; margin: 5px 0; }
            .message-content { line-height: 1.8; font-size: 16px; margin-bottom: 40px; }
            .signature-section { margin-top: 50px; padding-top: 20px; border-top: 1px dashed #ccc; }
            .footer { text-align: center; margin-top: 50px; font-size: 12px; color: #95a5a6; }
            @media print {
              body { padding: 20px; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1 class="print-title">PRESIDENT'S MESSAGE</h1>
            <p class="print-subtitle">Annual Leadership Address - ${year}</p>
          </div>
          
          <div class="president-info">
            <h2 class="president-name">${name}</h2>
            <p class="president-position">${position}</p>
            <p><strong>Organization:</strong> ${organization}</p>
            <p><strong>Date:</strong> ${currentDate}</p>
          </div>
          
          <div class="message-content">
            ${message.split('\n').map(p => `<p>${p.trim()}</p>`).join('')}
          </div>
          
          ${showSignature ? `
            <div class="signature-section">
              <p><strong>Signed,</strong></p>
              <p style="font-size: 18px; font-weight: bold;">${name}</p>
              <p>${position}</p>
              <p>${organization}</p>
            </div>
          ` : ''}
          
          <div class="footer">
            <p>© ${organization} ${year} | Confidential & Proprietary</p>
            <p>Document generated on ${new Date().toLocaleString()}</p>
          </div>
          
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 1000);
            };
          </script>
        </body>
      </html>
    `;

    // Open print window
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    
    // Reset printing state
    setTimeout(() => {
      setIsPrinting(false);
    }, 2000);
  };

  // Function to copy message to clipboard
  const handleCopyToClipboard = () => {
    const textToCopy = `${name} - ${position}\n${organization}\n\n${message}`;
    
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        // Show temporary success message
        const btn = document.querySelector('.btn-copy');
        if (btn) {
          const originalText = btn.textContent;
          btn.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Copied!
          `;
          btn.style.background = '#2ecc71';
          
          setTimeout(() => {
            btn.innerHTML = `
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="currentColor" strokeWidth="2"/>
              </svg>
              Copy Text
            `;
            btn.style.background = '';
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        alert('Failed to copy message to clipboard');
      });
  };

  // Function to share via email
  const handleShareEmail = () => {
    const subject = `President's Message from ${name} - ${year}`;
    const body = `
Dear Team,

Please find the President's Message for ${year}:

From: ${name}
Position: ${position}
Organization: ${organization}

Message:
${message}

Best regards,
${organization}
    `;
    
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="president-message-container" >
      {/* Header Section */}
      <div className="president-message-header">
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dot"></div>
        </div>
        <h2 className="message-title">President's Message</h2>
        <p className="message-subtitle">Leadership Vision for {year}</p>
        
        {/* Download Status Indicator */}
        {isDownloading && (
          <div className="download-status">
            <div className="status-spinner"></div>
            <span>Preparing download...</span>
          </div>
        )}
        
        {isPrinting && (
          <div className="print-status">
            <div className="status-spinner"></div>
            <span>Opening print dialog...</span>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="president-message-content">
        {/* Left Side - President Info */}
        <div className="president-info-section">
          <div className="president-avatar">
            {avatar ? (
              <img src={avatar} alt={name} className="avatar-image" />
            ) : (
              <div className="avatar-placeholder">
                <span className="avatar-initials">
                  {name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
            )}
            <div className="avatar-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
                      fill="#FFD700" stroke="#FFA500" strokeWidth="1"/>
              </svg>
            </div>
          </div>

          <div className="president-details">
            <h3 className="president-name">{name}</h3>
            <p className="president-position">{position}</p>
            <p className="president-organization">{organization}</p>
            
            <div className="president-stats">
              <div className="stat-item">
                <span className="stat-number">{year.substring(0,4)}</span>
                <span className="stat-label">Year</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">
                  {enableDownload ? '✓' : '✗'}
                </span>
                <span className="stat-label">Download</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">
                  {enablePrint ? '✓' : '✗'}
                </span>
                <span className="stat-label">Print</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Message */}
        <div className="message-section">
          <div className="message-quote">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M10 30V20C10 13.3726 15.3726 8 22 8H26M30 30V20C30 13.3726 24.6274 8 18 8H14" 
                    stroke="#3498db" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>

          <div className="message-text">
            {typeof message === 'string' ? (
              message.split('\n').map((paragraph, index) => (
                <p key={index} className="message-paragraph">
                  {paragraph.trim()}
                </p>
              ))
            ) : (
              <div className="custom-message">{message}</div>
            )}
          </div>

          {/* Signature Section */}
          {showSignature && (
            <div className="signature-section">
              <div className="signature-line"></div>
              <div className="signature-details">
                <span className="signature-name">{name}</span>
                <span className="signature-title">{position}</span>
              </div>
            </div>
          )}

          {/* Date Section */}
          {showDate && (
            <div className="date-section">
              <div className="date-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" 
                        stroke="#7f8c8d" strokeWidth="2"/>
                  <line x1="3" y1="10" x2="21" y2="10" 
                        stroke="#7f8c8d" strokeWidth="2"/>
                  <line x1="8" y1="2" x2="8" y2="6" 
                        stroke="#7f8c8d" strokeWidth="2"/>
                  <line x1="16" y1="2" x2="16" y2="6" 
                        stroke="#7f8c8d" strokeWidth="2"/>
                </svg>
              </div>
              <span className="date-text">{currentDate}</span>
            </div>
          )}

          {/* Action Buttons */}
          <div className="action-buttons">
            {enableDownload && (
              <button 
                className="btn-primary" 
                onClick={handleDownload}
                disabled={isDownloading}
              >
                {isDownloading ? (
                  <>
                    <div className="btn-spinner"></div>
                    Downloading...
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M12 5V19M12 5L6 11M12 5L18 11" 
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Download Message
                  </>
                )}
              </button>
            )}
            
            {enablePrint && (
              <button 
                className="btn-secondary" 
                onClick={handlePrint}
                disabled={isPrinting}
              >
                {isPrinting ? (
                  <>
                    <div className="btn-spinner"></div>
                    Printing...
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9V2H18V9M6 18H4C2.89543 18 2 17.1046 2 16V11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V16C22 17.1046 21.1046 18 20 18H18M6 14H18V22H6V14Z" 
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Print Message
                  </>
                )}
              </button>
            )}
            
            <button className="btn-copy" onClick={handleCopyToClipboard}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="currentColor" strokeWidth="2"/>
              </svg>
              Copy Text
            </button>
            
            <button className="btn-share" onClick={handleShareEmail}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 6L12 13L2 6" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Share via Email
            </button>
          </div>

          {/* Format Options */}
          <div className="format-options">
            <p className="format-title">Download Formats:</p>
            <div className="format-buttons">
              <button 
                className="format-btn"
                onClick={() => {
                  const content = `
<!DOCTYPE html>
<html>
<head>
    <title>President's Message - ${name}</title>
    <style>
        body { font-family: Arial, sans-serif; padding: 40px; }
        .header { text-align: center; }
        .content { line-height: 1.6; }
    </style>
</head>
<body>
    <div class="header">
        <h1>President's Message</h1>
        <h2>${name}</h2>
        <h3>${position}</h3>
    </div>
    <div class="content">
        ${message}
    </div>
</body>
</html>
                  `;
                  const blob = new Blob([content], { type: 'text/html' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `president_message_${year}.html`;
                  a.click();
                }}
              >
                HTML
              </button>
              <button 
                className="format-btn"
                onClick={handleDownload}
              >
                TXT
              </button>
              <button 
                className="format-btn"
                onClick={() => {
                  // For PDF, you would typically use a library like jsPDF
                  // This is a simplified version
                  alert('PDF export requires jsPDF library. Using text format instead.');
                  handleDownload();
                }}
              >
                PDF
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Stats */}
      <div className="message-footer">
        <div className="footer-stat">
          <span className="footer-stat-number">
            {enableDownload ? '✓' : '—'}
          </span>
          <span className="footer-stat-label">Downloadable</span>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-stat">
          <span className="footer-stat-number">
            {enablePrint ? '✓' : '—'}
          </span>
          <span className="footer-stat-label">Printable</span>
        </div>
        <div className="footer-divider"></div>
        <div className="footer-stat">
          <span className="footer-stat-number">4</span>
          <span className="footer-stat-label">Export Formats</span>
        </div>
      </div>
    </div>
  );
};

PresidentMessage.defaultProps = {
  name: "John Smith",
  position: "President & CEO",
  organization: "Innovation Corporation",
  message: "On behalf of our entire team, I am delighted to welcome you to our annual report. This year has been marked by remarkable achievements, innovative breakthroughs, and meaningful partnerships. As we look ahead, we remain committed to our vision of excellence and our mission to create lasting value for all our stakeholders.",
  year: "2024",
  showSignature: true,
  showDate: true,
  enableDownload: true,
  enablePrint: true
};

export default PresidentMessage;